import React, { useEffect, useState } from 'react';
export function StickyRibbon() {
  const [timeLeft, setTimeLeft] = useState({
    hours: '00',
    minutes: '00',
    seconds: '00'
  });
  // Format date: "Miércoles 17 de Junio"
  const getFormattedDate = () => {
    const now = new Date();
    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const dayName = days[now.getDay()];
    const dayNumber = now.getDate();
    const monthName = months[now.getMonth()];
    return `${dayName} ${dayNumber} de ${monthName}`;
  };
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const endOfDay = new Date();
      endOfDay.setHours(23, 59, 59, 999);
      const diff = endOfDay.getTime() - now.getTime();
      if (diff <= 0) {
        setTimeLeft({
          hours: '00',
          minutes: '00',
          seconds: '00'
        });
      } else {
        const h = Math.floor(diff / (1000 * 60 * 60) % 24);
        const m = Math.floor(diff / (1000 * 60) % 60);
        const s = Math.floor(diff / 1000 % 60);
        setTimeLeft({
          hours: h.toString().padStart(2, '0'),
          minutes: m.toString().padStart(2, '0'),
          seconds: s.toString().padStart(2, '0')
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-[100] w-full bg-brand-navy border-b border-[#D98BAF]/30 shadow-[0_10px_30px_-5px_rgba(217,139,175,0.2)] py-3 px-4 md:px-8" data-id="element-319">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2" data-id="element-320">
        {/* Text Side */}
        <div className="flex flex-col items-start" data-id="element-321">
          <h2 className="text-[#D98BAF] font-black md:text-2xl tracking-tight uppercase drop-shadow-[0_0_8px_rgba(217,139,175,0.4)] text-[14px]" data-id="element-322">
            20 CUPOS PROGRAMA + CONSULTORÍAS ✨
          </h2>
          <p className="text-brand-cream font-medium md:text-lg mt-1 md:mt-2 text-[10px]" data-id="element-323">
            Finaliza hoy {getFormattedDate()}
          </p>
        </div>

        {/* Timer Side */}
        <div className="flex items-center gap-1 md:gap-4" data-id="element-324">
          <TimerBox value={timeLeft.hours} label="HRS" data-id="element-325" />
          <span className="text-[#D98BAF] font-bold text-lg md:text-3xl mt-[-12px] md:mt-[-20px]" data-id="element-326">
            :
          </span>
          <TimerBox value={timeLeft.minutes} label="MIN" data-id="element-327" />
          <span className="text-[#D98BAF] font-bold text-lg md:text-3xl mt-[-12px] md:mt-[-20px]" data-id="element-328">
            :
          </span>
          <TimerBox value={timeLeft.seconds} label="SEG" data-id="element-329" />
        </div>
      </div>
    </div>;
}
function TimerBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-330">
      <div className="bg-brand-navy border border-[#D98BAF]/40 rounded-lg md:rounded-xl w-9 h-11 md:w-16 md:h-20 flex items-center justify-center shadow-[0_0_15px_rgba(217,139,175,0.15)]" data-id="element-331">
        <span className="text-[#D98BAF] font-black text-lg md:text-4xl font-mono drop-shadow-[0_0_10px_rgba(217,139,175,0.5)]" data-id="element-332">
          {value}
        </span>
      </div>
      <span className="text-[#D98BAF] font-semibold text-[6px] md:text-[11px] mt-1 tracking-widest" data-id="element-333">
        {label}
      </span>
    </div>;
}